import React, { useState, useEffect } from 'react';

import PropTypes from "prop-types";

import { getCarAsset } from './../../api/cars';

import { useCarsState } from './../../providers/CarsProvider';

import { useHistory } from 'react-router-dom';

const CarAsset = ( { id } ) => {

    const [ state, setState ] = useState( {} );

    const [ carsState, carsDispatch ] = useCarsState();

    const history = useHistory();

    useEffect(()=>{

        if( !carsState.carDetails[ id ] ){

            getCarAsset( id ).then( data => {

                carsDispatch( { type:'updateCar', data } );
            });
        }
    }, [] )

    useEffect( () => {

        setState( { ...carsState.carDetails[ id ] } );

    }, [ carsState.carDetails[ id ] ] )

    const handleOnView = () => {

        history.push(`/cars/${id}`)
    }

    return(
        <div className="pointer overflow-hidden pos-rel z-1" onDoubleClick={ handleOnView } style={{flex:'1 0 calc( 50% - 10px )', minHeight:"calc( 50% - 20px )", minwWidth:"calc( 50% - 10px )"}}>
            <div className="ar-5625 bg-cover d-flex flex-column align-items-start" style={ { gap:20, backgroundImage: `url(" ${ state.thumbnail || "" } ")` } }>
                <img src={ state.logo } width={ 220 } />
                <button onClick={ handleOnView } className="small text-white px-5 py-1 mt-1" style={{ marginLeft:30, backgroundColor:'#222222', borderRadius:30 }}><h5>build</h5></button>
            </div>
            <h4 className="pos-abs tr-0 m-1 z-2 text-white">{ state.label }</h4>
        </div>
    )
}

CarAsset.propTypes = {
    id: PropTypes.number.isRequired
}

export default CarAsset;
